import { OperationTypeLiabilities, SettlementType, Ticket } from "./Entity";

export class LiabilitiesModel extends Ticket {
  // Dados Carteira

  portfolioDocument: string = null;
  portfolioBank: string = null;
  portfolioBranch: string = null;
  portfolioAccount: string = null;
  portfolioName: string = null;
  isInternalFund = false;
  portfolioCode: string = null;
  portfolioCetipAccount: string = null;
  portfolioFundId: number = null;
  portfolioFundAccountId: number = null;

  // Dados da Operação

  operationTypeId: OperationTypeLiabilities = null;
  fullRedeem: boolean = null;
  settlementTypeId: SettlementType = null;
  isSecondaryMarket: boolean = null;
  operationValue: number = null;
  amount: number = null;
  quotaValue: number = null;
  settlementDate: Date = null;
  quotationDate: Date = null;
  subscriptionDate: Date = null;
  hasSameOwnership: boolean = null;
  isCetipVoice: boolean = null;
  cetipVoiceId: string = null;

  // - Dados do Fundo Investido

  acquiredFundSourceId: string = null;
  fundName: string = null;
  fundDocument: string = null;
  isFIDC = false;
  isNewFund = false;
  issuerName: string = null;
  isManualSettlementDate: boolean = null;
  scheme: string = null;
  fundAdministrator: string = null;

  fundBank: string = null;
  fundAccount: string = null;
  fundBranch: string = null;

  // - Dados do Cotista

  isNewShareholder = false;
  shareholderHasAccount = true;

  // - Dados da Contraparte

  counterpartName: string = null;
  counterpartDocument: string = null;
  counterpartCetipAccount: string = null;
  command = "0";
  isNewCounterpart = false;

  annotations: string = null;

  tempTicketId: any = null;

  constructor() {
    super();
  }
}
